import * as introData from './IntroData';
import introJs from 'intro.js/intro.js';
import 'intro.js/introjs.css';
import 'intro.js/themes/introjs-modern.css';
import '../assets/css/intro-guide.styl';
const { introJS } = require('intro.js');

export default {
  data() {
    return {
      introSteps: [],
      isIntroValidate: false,
      introStepNo: 0,
      introNext: false,
      introPrev: false,
      introStart: true,
      introCurrentPage: '',
    };
  },
  computed: {
    introCurrentStep() {
      let getSession = this.$session.get(this.introSessionName);
      return getSession ? getSession : 0;
    },
    introFilterSteps() {
      return this.introSteps.filter(function (step) {
        return typeof step.element == 'undefined' || step.element !== null;
      });
    },
    introSessionName() {
      return 'session-' + this.introCurrentPage;
    },
  },
  watch: {
    introStepNo() {
      this.introNext = false;
      this.introPrev = false;
      this.$session.start();
      this.$session.set(this.introSessionName, this.introStepNo);
    },
  },
  methods: {
    async introRender(bullet = true) {
      let _this = this;
      let jumpStep = this.introCurrentStep + 1;

      if (!this.$auth.user()) return false;

      await introJs()
        .setOptions({
          nextLabel: '→',
          prevLabel: '←',
          skipLabel: 'Skip',
          disableInteraction: true,
          showBullets: bullet,
          steps: _this.introFilterSteps,
        })
        .goToStepNumber(jumpStep)
        .start()
        .onbeforeexit(function () {
          return _this.introStore();
        })
        .onbeforechange(function () {
          _this.introStepDetect();
        });

      this.introSkipAll();
    },

    introSkipAll() {
      let _this = this;
      let btnDiv = document.getElementsByClassName('introjs-tooltipbuttons')[0];
      var button = document.createElement('BUTTON');
      button.innerHTML = 'Turn off Tour';
      button.setAttribute('class', 'introjs-turnoff');
      btnDiv.appendChild(button);
      button.onclick = function () {
        let confirm = _this.introStore(
          'Are you sure you want to turn off for all pages?',
          true
        );
        if (confirm) introJs().exit();
      };
    },

    introStepDetect() {
      let _this = this;

      if (this.introStart) this.introStart = false;

      if ($('.introjs-nextbutton').is(':visible')) {
        $(document).on('click', '.introjs-nextbutton', function (event) {
          if (
            !_this.introNext &&
            _this.introStepNo < _this.introFilterSteps.length - 1
          ) {
            _this.introNext = true;
            ++_this.introStepNo;
          }
        });
      }

      if ($('.introjs-prevbutton').is(':visible')) {
        $(document).on('click', '.introjs-prevbutton', function (event) {
          if (!_this.introPrev && _this.introStepNo > 0) {
            _this.introPrev = true;
            --_this.introStepNo;
          }
        });
      }
    },

    introStore(message, allSkip = false) {
      let isExit = true;

      if (
        this.introStepNo == 0 ||
        this.introStepNo != this.introFilterSteps.length - 1
      ) {
        isExit = confirm(
          message ? message : 'Are you sure you want to Skip for this page?'
        );
      }

      if (isExit) {
        this.$http
          .post('/intro', {
            value: this.introCurrentPage,
            all_skip: allSkip,
          })
          .then((data) => {
            this.introValidate = false;
            this.$session.remove(this.introSessionName);
          })
          .catch(() => {
            this.$notify('error', 'Encountered error, Please try again!');
          });
      }

      return isExit;
    },

    $_introFormat(name, prefix = null) {
      let convertPrefix = prefix ? prefix + '__' : '';
      //slugifyJs
      let convertName = name
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');
      return convertPrefix + convertName;
    },

    async introValidate() {
      await this.$http
        .get('/intro', {
          params: {
            value: this.introCurrentPage,
          },
        })
        .then((data) => {
          // Disable introjs
          this.isIntroValidate = false;
        });

      this.introStepNo += this.introCurrentStep;
    },

    async $_introHome() {
      this.introCurrentPage = 'client-home';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      let menu =
        this.$vuetify.breakpoint.width > 1024
          ? [...introData.headerMenu(), ...introData.asideMenu()]
          : introData.menuMobile();

      this.introSteps = [
        ...introData.welcome(this.$auth.user().name),
        ...menu,
        ...introData.contentHome(),
        ...introData.userManager(),
        ...introData.webinarCard(),
      ];

      await this.introRender(false);
    },

    async $_introUserManage() {
      this.introCurrentPage = 'user-manager';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [...introData.userManager()];

      await this.introRender();
    },

    async $_introLmsManager() {
      this.introCurrentPage = 'lms-manager';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [...introData.lmsManager()];

      await this.introRender();
    },

    async $_introLmsBuilder() {
      this.introCurrentPage = 'lms-builder';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [...introData.lmsBuilder()];

      await this.introRender();
    },

    async $_introOnDemandTraining() {
      this.introCurrentPage = 'on-demand-training';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [
        ...introData.onDemandTraining(),
        ...introData.unitCard(),
      ];

      await this.introRender();
    },

    async $_introUnitPage() {
      this.introCurrentPage = 'unit-page';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [...introData.unitPage()];

      await this.introRender();
    },

    async $_introLmsReport() {
      this.introCurrentPage = 'lms-report';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [...introData.OTDReport()];
      await this.introRender();
    },

    async $_introSecretShop() {
      let _this = this;
      this.introCurrentPage = 'secret-shop';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [...introData.secretShop()];

      await setTimeout(function () {
        _this.introRender();
      }, 2000);
    },

    async $_introSendReport(value, hasExcel = false) {
      this.introCurrentPage = value;

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [...introData.sendReport(hasExcel)];
      await this.introRender(false);
    },

    async $_introProfile() {
      this.introCurrentPage = 'profile';

      await this.introValidate();
      if (!this.isIntroValidate) return false;

      this.introSteps = [...introData.profile()];
      await this.introRender();
    },
  },
};
